/** Configuration for the simulated EMR system. */
const config = {
  backgroundUrl:
    '/public/medical-research-background.jpg',
  logoUrl:
    '/public/medical-research-logo.svg'

};

export default config;
